import React, { useCallback, useEffect, useState } from "react";
import PermitContent from "./PermitContent";
import "./page.css";
import {
  Box,
  Card,
  CardContent,
  Grid,
  CardHeader,
  IconButton,
  Input,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Badge,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import {
  Button,
  Checkbox,
  Container,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import Text from "../Text/Text";
import {
  ArrowForwardIosRounded,
  CancelRounded,
  DeleteRounded,
  Edit,
  EditRounded,
  Label,
  ShoppingBasketRounded,
  ShoppingCart,
} from "@material-ui/icons";
import { Stepper } from "../Stepper/Stepper";
import { Step } from "../Stepper/Step";
import { StepperControlFooter } from "../Stepper/StepperControlFooter";
import { useStepper } from "../Stepper/hooks";
import TextInput from "../TextInput/TextInput";
import CreditCardText from "../TextInput/CreditCardText";
import Visa from "../../assets/image/VISA.png";
import TextInputWithMasking from "../TextInput/TextInputWithMasking";
import { useSelector } from "react-redux";
import { getAmericanStatesList } from "../../store/pay-citation/selector";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { usStates } from "../Forms/profile/StateList";
import { useDispatch } from "react-redux";
import { payCitation } from "../../store/citationDetail/action";
import CheckoutPermit from "./CheckoutPermit";
import CitationDetailsPage from "./CitationDetailsPage";
import moment from "moment";

import BuyPerimtsEditOrderModal from "../Modals/buypermits/BuyPermitsExitOrderModal";
import {
  getBuyPermitPaymentMethods,
  getTaxRateOrder,
  hideBuyPermitsExitOrderModal,
  hideBuyPermitThankYouModal,
  resetBuyPermitSelectedPermit,
  setBuyPermitEditVehicle,
  setBuyPermitSelectedPermit,
  showBuyPermitsExitOrderModal,
} from "../../store/buyPermits/action";
import { useHistory } from "react-router";
import { RouteService } from "../../services/route.service";
import { getCustomer } from "../../store/home/selector";
import { getUserContextData } from "../../store/login/selector";
import {
  getBuyPemitselectedVehicleState,
  getBuyPermitSelectedPermitsState,
} from "../../store/buyPermits/selector";
import { getProfileData } from "../../store/profile/selector";
import { getAddPermitSelectDateSelector } from "../../store/addPermitText/selector";

const useStyles = makeStyles((theme) => ({
  p5: {
    padding: "5px",
  },
  root: {
    minHeight: "calc(100vh - 302px)",
    width: "100%",
    // marginBottom: "4rem",
    // padding: "10px",
  },
  rightBox: {
    height: "250px",
    width: "500px",
    backgroundColor: theme.palette.primary.main,
    border: "2px solid black",
    borderRadius: "10px",
    marginLeft: "14%",
  },
  rightGrid: {
    justifyContent: "center",
    alignItems: "center",
  },
  toolbarContainer: {
    marginBottom: "10px",
    position: "relative",
    padding: "10px",
  },
  rightIconsContainer: {
    position: "absolute",
    right: "20px",
    top: 0,
  },
  dflex: {
    display: "flex",
  },
  alignBase: {
    alignItems: "baseline",
  },
  fGap: {
    gap: "10px",
  },
  secondContainer: {
    textAlign: "center",
  },

  active: {
    background: "gray",
  },
  // thirdStepFirstDiv: {
  //     border: "1px solid black",
  //     borderRadius: "5px",
  //     boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
  //     width: "200px"

  // },
  vehicleCardHeader: {
    background: "#20419a",
    color: "white",
  },
  vehiclesUl: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    fontSize: "11px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main,
    padding: "4px",
  },
  stepperPadding: {
    padding: "15px",
  },
  firstStepFirstChildMaindiv: {
    padding: "6px",
    width: "auto",
    borderRadius: 9,
    color: "white",
    marginRight: "15px",
    height: "fit-content",
    border: "1px solid gray",
    textAlign: "center",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "auto",
    color: "white",
    borderRadius: "2px",
    // marginRight: "15px",
  },
  tablehead: {
    background: "#20419a",
  },
  tableheadChild: {
    color: "white",
  },
  fWrap: {
    flexWrap: "wrap",
    width: "40px",
  },
  rightContainer: {
    marginLeft: "145px",
    minHeight: "20px",
  },
  rightContainerHeader: {
    background: theme.palette.primary.main,
    top: "0",
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "gray !important",
    },
  },
  alignCenter: {
    alignItems: "center",
  },
  textField: {
    "& div": {
      padding: "7px 12px 10px",
    },
    width: "100%",
  },
  spaceTop: {
    marginTop: 25,
  },
  img: {
    width: 60,
  },
  link: {
    cursor: "pointer",
  },
  stateText: {
    paddingBottom: 8,
  },
  steptotalflex: {
    display: "flex",
  },
  w100: {
    width: "100%",
  },
  borderBottom: {
    borderBottom: "1px solid #a39b9b",
  },
  checkouttotal: {
    border: "1px solid black",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "300px",
    position: "absolute",
    right: "5px",
  },
  checkoutgrid: {
    position: "absolute",
    right: "10px",
  },
  checkoutvechile: {
    fontWeight: "600",
    fontSize: "15px",
    display: "flex",
  },
  checkoutfirstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    textAlign: "center",
  },
  checkoutdflex: {
    display: "flex",
    border: "1px solid gray",
    width: "100%",
  },
  checkoutdflextable: {
    display: "flex",
  },
  checkoutml: {
    marginLeft: "20px",
  },
  checkoutinstruction: {
    border: "1px solid black",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "350px",
    position: "absolute",
    top: "250px",
    right: "5px",
  },
  checkoutsubmit: {
    top: "240px",
    width: "290px",
  },
  checkoutchangedflex: {
    display: "flex",
    justifyContent: "space-between",
  },
  checkoutTermandCondition: {
    position: "relative",
    top: "235px",
    width: "288px",
    textAlign: "center",
    color: "black",
  },

  backgroundtheme: {
    color: theme.palette.primary.main,
  },
}));
export default function ViewPermitCart(props) {
  const { StylingItem, handletoggleAddPermitPage, selectedDate, permitType, setPermitType } = props;
  const classes = useStyles();
  const statesList = useSelector(getAmericanStatesList);
  const getSelectDate = useSelector((state) => state?.AddPermitReducerText?.setpermitText)
  // const sdasfsdfgsd = useSelector((state) => state?.AddPermitReducerText?.setpermitText)
  //  let data =  localStorage.getItem("selectedDate")
  const citationDetailState = useSelector((state) => state.citationDetailState);
  const dispatch = useDispatch();
  const [step, setStep] = React.useState();
  const [shippingCheckbox, setShippingCheckbox] = useState(true);
  const [stepper, next, back, handleBack] = useStepper({ steps: 3 });
  const [state, setState] = React.useState({});
  const [orderList, setorderList] = useState([]);
  const [allowedNoOfPermit, setAllowedNoOfPermit] = useState();

  const user = useSelector(getUserContextData);
  const group = useSelector(getCustomer);
  /** get profile data from reducer  */

  const getBuyPermitsExitOrderModal = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitsExitOrderModal
  );
  const getBuyPermitSelectedPermitsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits
  );
  const getBuyPemitSelectedVehicleState = useSelector(
    (state) => state?.exitOrderReducer?.buyPemitSelectedVehicle
  );
  const counterState = useSelector(
    (state) => state?.exitOrderReducer?.counterState
  );
  const getPaymentMethodState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitPaymentMethods
  );
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );

  const [isOpenExitOrderModal, setExitOrderModal] = useState(
    getBuyPermitsExitOrderModal
  );
  const [selectedVehicleData, setSelectedVehicleData] = useState(
    getBuyPemitSelectedVehicleState
  );
  const [selectedPerimtData, setSelectedPermitData] = useState(
    getBuyPermitSelectedPermitsState
  );
  const permitTaxRatePrice = useSelector((state) => state?.exitOrderReducer?.buyPermitTaxRatePrice);

  const profileStore = useSelector(getProfileData);
  const { clientName } = profileStore;

  const history = useHistory();

  const id = profileStore?.id;
  var driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item, index) => {
        if (item?.name == "Status") {
          return item;
        }
      }
    );

  var driverBAStatus = profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.map((item => {
      if (item.name !== 'VIP') {
        return item.value
      }
    }))

  let withoutUndeifne = driverBAStatus?.filter((ele) => ele !== undefined)

  var status = Array.isArray(driverStatus) && driverStatus[0]?.value;

  useEffect(() => {
    dispatch(getTaxRateOrder(user?.user?.userGroup))
  }, [])

  useEffect(() => {

    setExitOrderModal(getBuyPermitsExitOrderModal);
    // dispatch(getBuyPermitPaymentMethods({ id: id, status: status }));
    dispatch(getBuyPermitPaymentMethods({ status: withoutUndeifne, clientUserName: user?.user?.userGroup }));
    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
    } else {
      // dispatch(getBuyPermitPaymentMethods({ id: id, status: status }));
      dispatch(getBuyPermitPaymentMethods({ status: withoutUndeifne, clientUserName: user?.user?.userGroup }));
    }
  }, []);

  useEffect(() => {
    setSelectedVehicleData(getBuyPemitSelectedVehicleState);
  }, [getBuyPemitSelectedVehicleState]);

  useEffect(() => {
    setSelectedPermitData(getBuyPermitSelectedPermitsState);
  }, [getBuyPermitSelectedPermitsState]);

  const location = {
    pathname: RouteService.home(group) + "/dashboard",
  };

  const [permit, setpermit] = useState([]);
  const [showHide, setshowHide] = useState({});
  const [checkout, setCheckout] = useState(false);
  const [taxTotal, setTaxtotal] = useState();

  var totalPrice = 0;
  var totalFee = 0;
  var tax = 0;
  var grassTotal = 0;




  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };

  React.useEffect(() => {
    setorderList(driverViewOrderStateList);
  }, [driverViewOrderStateList]);

  function isDateGrater(date1, date2) {
    if (date1.getFullYear() > date2.getFullYear()) {
      return true;
    } else if (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() > date2.getMonth()
    ) {
      return true;
    } else if (
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() >= date2.getDate()
    ) {
      return true;
    }
    return false;
  }

  var PerchasedPermitList =
    Array.isArray(orderList) &&
    orderList?.filter((pmtOrder, i) => {
      let date1 = pmtOrder?.lines[0]?.item?.validEndDate;
      let orderDate = new Date(date1);
      let date2 = new Date();
      if (isDateGrater(orderDate, date2)) {
        return pmtOrder?.lines[0]?.item;
      }
    });

  useEffect(() => {
    var allowedpmt =
      Array.isArray(getPaymentMethodState) &&
      getPaymentMethodState?.filter((itm) => {
        if (itm?.ruleType === "MAX_NUMBER_PERMIT_SALES") {
          return itm;
        }
      });

    setAllowedNoOfPermit(allowedpmt[0]?.ruleValues[0]);
  }, [counterState, getPaymentMethodState]);

  const addAnOtherPermit = async (e) => {
    dispatch(setBuyPermitEditVehicle({ permit_id: 0, vehicleEditList: 0 }));
    // await handletoggleAddPermitPage("add");
    await handletoggleAddPermitPage("typeAnythigs");
  };
  const gotochekoutCompoent = (e) => {
    dispatch(hideBuyPermitThankYouModal());
    setCheckout(true);
  };
  const handleShow = (permit) => {
    let tmpState = { ...showHide };
    tmpState[permit] = true;
    setshowHide(tmpState);
  };
  const handleHide = (permit) => {
    let tmpState = { ...showHide };
    tmpState[permit] = false;
    setshowHide(tmpState);
  };
  const handleDelete = async (permitId) => {
    let tmpState = [...permit];
    let tmpIndex = tmpState.findIndex((e) => e?.permit?.id === permitId);
    tmpState.splice(tmpIndex, 1);
    setpermit(tmpState);
    dispatch(resetBuyPermitSelectedPermit(tmpState));
  };

  const handleEdit = async (permitId, vehicleId) => {
    dispatch(
      setBuyPermitEditVehicle({
        permit_id: permitId,
        vehicleEditList: vehicleId,
      })
    );
    handletoggleAddPermitPage("add");
  };

  // checkout part
  const handleNext = (data) => () => {
    next(stepper.current);
  };
  const handleCreditCardChange = () => {
    handleBack(0);
  };
  const handleBillingChange = () => {
    handleBack(1);
  };
  const getStep = (step) => {
    setStep(step);
  };
  useEffect(() => {
    getStep(stepper.current);
    setPermitType("STD_PERMIT")
    // if (selectedDate !== "") {

    //   // selectedPerimtData[0]?.vehicles?.push({selectedDate : selectedDate})
    //   // selectedPerimtData?.permit?.Date = selectedDate
    //   selectedPerimtData?.map((selectedpermist,index) => {
    //     selectedpermist.permit.data === selectedDate[index] 
    //   })
    //   setpermit(selectedPerimtData);
    // } else {

    // }
    setpermit(selectedPerimtData);
  }, [selectedPerimtData]);
  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const validation = () => {
    let isValidate = true;
    if (stepper.current === 0) {
      if (
        state &&
        state.cvv &&
        state.credit &&
        state.expireDate &&
        state.cardHolderName &&
        state.credit?.length === 19 &&
        state.cvv?.length === 3 &&
        state.expireDate?.length === 5
      ) {
        isValidate = false;
      }
    }
    let isEmail = false;
    let rejax =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (rejax.test(state.email)) {
      isEmail = true;
    }

    if (stepper.current === 1) {
      if (isEmail) {
        isValidate = false;
      }
    }
    if (stepper.current === 2) {
      isValidate = false;
    }
    return isValidate;
  };

  const handleSubmit = () => {
    //handle submit
    let splitable = state.expireDate.split("/");
    let stateName = usStates.filter((e) => e.abbreviation === state.state)[0]
      .name;
    let payObj = {
      paymentMethod: {
        value: "ONLINE_CC",
        label: "Credit Card",
      },
      citationId: citationDetailState,
      cardDetails: {
        cardNumber: state.credit.replaceAll(/\s/g, ""),
        cardExpireMonth: splitable[0],
        cardExpireYear: splitable[1],
        cvv: state.cvv,
        nameOnCard: state.cardHolderName,
        billingAddress: {
          id: 99,
          defaultFlag: true,
          line1: `${state.city}, ${stateName}`,
          line2: `${state.city}, ${stateName}`,
          city: state.city,
          state: {
            name: stateName,
            code: state.state,
          },
          zip: state.zipCode,
        },
      },
    };
    dispatch(payCitation(payObj));
  };

  let price = 0;
  let fee = 0;
  Array.isArray(permit) &&
    permit.map((item) => {
      price = price + item?.price;
      fee = fee + item?.fee;
    });

  const CancelBuyPermitsExitOrderModal = useCallback((type) => {
    dispatch(hideBuyPermitsExitOrderModal());
  });

  const ConfirmBuyPermitsExitOrderModal = useCallback((type) => {
    // history.push(location);
    history.push(RouteService.buyPermits);
    dispatch(hideBuyPermitsExitOrderModal());
  });

  const cancelShowBuyPermitsExitOrderModal = useCallback((type) => {
    history.push(RouteService.buyPermits);
    dispatch(showBuyPermitsExitOrderModal());
  });


  const validDatestart = (validDate, pushData, allData) => {
    if (allData?.permit?.permitType == permitType) {
      return moment(validDate)?.format("MM/DD/YYYY")
    } else {
      return moment(pushData)?.format("MM/DD/YYYY")
    }
  }



  // const validDate = 20;
  const validSelectDate = (pusData, validDate, allData, endDate) => {
    // var isafter = moment(selectedDate).add(validDate, 'days').isAfter(endDate);
    // if(!selectedDate){
    //   return moment(endDate)?.format( "MM/DD/YYYY" ) 
    // }else if(isafter === false){
    //   return moment(selectedDate).add(validDate, 'days')?.format("MM/DD/YYYY")
    // }
    if (allData?.permit?.permitType === "STD_PERMIT") {
      return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
    }
    else if (pusData && allData?.permit?.permitType === "EFP") {
      var isafter = moment(pusData).add(validDate, 'days').isAfter(endDate);
      if (isafter === true) {
        return moment(allData?.permit?.validEndDate)?.format("MM/DD/YYYY")
      } else {
        return moment(pusData).add(validDate, 'days')?.format("MM/DD/YYYY")
      }
    }
  }
  // const validSelectDate = (endDate, validDate)=>{
  //   // var isafter = moment(selectedDate).add(validDate, 'days').isAfter(endDate);
  //   // if(!selectedDate){
  //   //   return moment(endDate)?.format( "MM/DD/YYYY" ) 
  //   // }else if(isafter === false){
  //   //   return moment(selectedDate).add(validDate, 'days')?.format("MM/DD/YYYY")
  //   // }
  //   if(endDate || validDate){
  //     return moment(endDate)?.format( "MM/DD/YYYY" ) 
  //   }
  // }

  return (
    <>
      <section style={stylingVal && stylingVal} className="page-wrapper page_mrb">
        {checkout ? (
          <CheckoutPermit
            selectedDate={selectedDate}
            setCheckout={setCheckout}
            handletoggleAddPermitPage={handletoggleAddPermitPage}
          />
        ) : (
          <Container maxWidth={"xl"}>
            <div>
              <div className={classes.toolbarContainer}>
                <div className={classes.innerFlex}>
                  <Text
                    color={props.StylingItem && props.StylingItem.bodyColor}
                    variant={"h6"}
                    className={classes.backgroundtheme}
                    style={{ fontWeight: '600', fontSize: '1.6rem' }}
                  >
                    <h1 style={{ margin: 0 }} tabIndex='0'>  Shopping Cart</h1>
                  </Text>
                  <Divider />
                </div>
                <div
                  className={`${classes.rightIconsContainer} ${classes.dflex}`}
                >
                  <IconButton
                  title="ShoppingCart">
                    <Badge color="primary" badgeContent={selectedPerimtData?.length || 0}>
                      <ShoppingCart
                        className={classes.backgroundtheme}
                        onClick={(e) => handletoggleAddPermitPage("view")}
                      />
                    </Badge>
                  </IconButton>
                  <IconButton
                  title="Cancel">
                    <CancelRounded
                      className={classes.backgroundtheme}
                      //onClick={(e) => handletoggleAddPermitPage(null)}
                      onClick={cancelShowBuyPermitsExitOrderModal}
                    />
                  </IconButton>
                </div>
              </div>

              <Grid container spacing={2}>
                <Grid item lg={8} md={8} xs={12}>
                  {permit?.length <= 0 ? (
                    <div className={classes.alignCenter}>
                      Your Shopping Cart is empty.
                    </div>
                  ) : (
                    <>
                      <Card style={{ position: "relative" }}>
                        <CardHeader
                        tabIndex='0'
                          style={{ fontSize: 17 }}
                          title={"PERMIT"}
                          className="card-header"
                        />
                        <CardContent className="scrollable-cart">
                          <>
                            {Array.isArray(permit) &&
                              permit?.map((row) => {
                                // totalPrice=totalPrice+row?.permit?.price*row?.vehicles?.length;
                                // totalFee = totalFee + row?.permit?.fee * row?.vehicles?.length;
                                totalPrice = totalPrice + row?.permit?.price;
                                totalFee = totalFee + row?.permit?.fee;
                                {/* tax = 0; */ }
                                tax = ((totalPrice + totalFee) * permitTaxRatePrice?.taxRate) / 100 || 0.00;
                                {/* setTaxtotal(tax) */ }
                                grassTotal = totalPrice + totalFee + tax;

                                return (
                                  <>
                                    <div
                                      tabIndex="0"
                                      onKeyDown={(event) => {
                                        if (event.key === "Tab") {
                                          // event.preventDefault();
                                          // handleSelectPermit2(item.id);
                                          handleShow(row?.permit?.id)
                                        }
                                      }}
                                      className="d-flex contentwrapper relat"
                                      onMouseOver={(e) =>
                                        handleShow(row?.permit?.id)
                                      }
                                      onMouseLeave={(e) =>
                                        handleHide(row?.permit?.id)
                                      }
                                    >
                                      <div>
                                        <PermitContent permit={row?.permit} />
                                      </div>
                                      <div className="text-left">
                                        <p className="headinText">
                                          {`${row?.permit?.name}`} &nbsp;{" "}
                                          {/* <b>{row?.permit?.permitType}</b> */}
                                        </p>

                                        <p>
                                          {/* {`Good from ${moment(
                                            row?.permit?.permitType == permitType ? row?.permit?.validStartDate : row?.permit?.data
                                            // selectedDate ? selectedDate : row?.permit?.validStartDate
                                            // row?.permit?.validStartDate
                                          )?.format("MM/DD/YYYY")} to ${
                                            moment(
                                            row?.permit?.validEndDate
                                          )
                                          ?.format("MM/DD/YYYY")}`} */}
                                          Good from{" "}
                                          {moment(
                                            validDatestart(row?.permit?.validStartDate, row?.permit?.tdate, row)
                                          )?.format(
                                            "MM/DD/YYYY"
                                          )}{" "}
                                          to{" "} {validSelectDate(row?.permit?.tdate, row?.permit?.validDays, row, row?.permit?.validEndDate)}
                                        </p>
                                        <p>Price : ${row?.permit?.price?.toFixed(2) || (0).toFixed(2)}</p>
                                        <p>Fees : ${row?.permit?.fee?.toFixed(2) || (0).toFixed(2)}</p>
                                        {/* <p>{row?.permit?.allowedNoVehicles} item limit</p><br/> */}
                                        <div style={{ fontSize: "16px" }}>
                                          <table>
                                            {Array.isArray(row?.vehicles) &&
                                              row?.vehicles?.map(
                                                (item, index) => {
                                                  return (
                                                    <>
                                                      <tr>
                                                        <th className="min-w80">
                                                          {" "}
                                                          Vehicles {index +
                                                            1}{" "}
                                                        </th>
                                                        <td>
                                                          {" "}
                                                          {`${item?.year} ${item?.color} ${item?.make?.name} ${item?.model}`}{" "}
                                                          {item?.licensePlate?.state?.code}{""} -{
                                                            item?.licensePlate
                                                              ?.number
                                                          }{" "}
                                                          VIN : {item?.vin}
                                                        </td>
                                                      </tr>
                                                      {/* <tr>
                                                        <th>Price </th>
                                                        <th>
                                                          $
                                                          {row?.permit?.price?.toFixed(2) || (0).toFixed(2)}
                                                        </th>
                                                      </tr>
                                                      <tr>
                                                        <th>Fee :</th>
                                                        <th>
                                                          {" "}
                                                          <p>
                                                            {" "}
                                                            $
                                                            {row?.permit?.fee?.toFixed(2) || (0).toFixed(2)}
                                                          </p>
                                                        </th>
                                                      </tr> */}
                                                    </>
                                                  );
                                                }
                                              )}
                                          </table>
                                          {showHide[row?.permit?.id] ? (
                                            <div className="sticky-action-button">
                                              <IconButton
                                              title="Edit"
                                                onClick={() =>
                                                  handleEdit(
                                                    row?.permit?.id,
                                                    row?.vehicles
                                                  )
                                                }
                                              >
                                                <Edit />
                                              </IconButton>
                                              <IconButton
                                              title="Delete"
                                                onClick={(e) =>
                                                  handleDelete(row?.permit?.id)
                                                }
                                              >
                                                <DeleteRounded />
                                              </IconButton>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </>
                        </CardContent>
                      </Card>
                    </>
                  )}
                  <Container
                    style={{ textAlign: "center", padding: "10px 0px" }}
                  >
                    <Button
                      className="addanotherbutton"
                      // {{ backgroundColor: "#162daf", color: "white" }}
                      variant={"contained"}
                      onClick={addAnOtherPermit}
                      disabled={true}
                    // disabled={
                    //   (PerchasedPermitList &&
                    //     PerchasedPermitList?.length + permit?.length) >=
                    //     allowedNoOfPermit
                    //     ? true
                    //     : false
                    // }
                    >
                      ADD ANOTHER PERMIT
                    </Button>
                  </Container>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <Card className="thirdStepFirstDiv">
                    <CardHeader
                    tabIndex='0'
                      className={classes.vehicleCardHeader}
                      title="Summary"
                    ></CardHeader>
                    {/* <h2>Summary</h2> */}
                    <div style={{ textAlign: "center" }}>
                      <p>
                        <b>SUBTOTAL : ${totalPrice?.toFixed(2)}</b>
                      </p>
                      <p>FEES : ${totalFee?.toFixed(2)}</p>
                      <p>TAX : ${tax.toFixed(2) || 0.00}</p>
                    </div>
                    <Divider />
                    <p style={{ textAlign: "center" }}>
                      <b>Total : ${grassTotal?.toFixed(2)}</b>
                    </p>
                  </Card>
                  {/* <Container style={{ padding: "10px 0px" }}> */}
                  {permit?.length <= 0 ? (
                    <>
                      <Container
                        style={{ textAlign: "center", padding: "10px 0px" }}
                      >
                        <Button
                          variant={"contained"}
                          className="addanotherbuttons"
                          endIcon={
                            <ArrowForwardIosRounded className="borderRound" />
                          }
                          disableElevation
                          onClick={(e) => gotochekoutCompoent(e)}
                          disabled={true}
                        >
                          Proceed to checkout
                        </Button>
                      </Container>
                    </>
                  ) : (
                    <Button
                      variant={"contained"}
                      className="addanotherbuttons"
                      endIcon={
                        <ArrowForwardIosRounded className="borderRound" />
                      }
                      disableElevation
                      onClick={(e) => gotochekoutCompoent(e)}
                    >
                      Proceed to checkout
                    </Button>
                  )}
                  {/* </Container> */}
                </Grid>
              </Grid>
              <BuyPerimtsEditOrderModal
                isOpenExitOrderModal={isOpenExitOrderModal}
                CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
                ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
              />
            </div>
          </Container>
        )}
      </section>
    </>
  );
}
